enum SkapaFontSizeEnum {
	fontSize50 = 12,
	fontSize75 = 14,
	fontSize100 = 16,
	fontSize200 = 18,
	fontSize300 = 20,
	fontSize400 = 22,
	fontSize500 = 25,
	fontSize600 = 28,
	fontSize700 = 32,
	fontSize800 = 36,
	fontSize1000 = 45,
	fontSize1100 = 50
}

export default SkapaFontSizeEnum;
